import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const getConfiguracaoTelegram = () =>
  api.get("/configuracao", { params: { grupo: "telegram" } }).then(r => r.data);

export const setConfiguracao = (chave, valor) =>
  api.put("/configuracao", { chave, valor }).then(r => r.data);

export const testarTelegram = () =>
  api.post("/telegram/testar").then(r => r.data);

export const enviarPrazosAgora = () =>
  api.post("/telegram/enviar-prazos").then(r => r.data);

export const getColaboradoresTelegram = () =>
  api.get("/colaboradores/telegram").then(r => r.data);

export const setColaboradorTelegram = (nome, chat_id) =>
  api.put(`/colaboradores/${encodeURIComponent(nome)}/telegram`, { chat_id }).then(r => r.data);
